import type { CRMAccount } from '../../types/crm';
import type { CRMAccountWithDeletedAt } from './types';

export const filterActiveAccounts = (accounts?: CRMAccountWithDeletedAt[]): CRMAccount[] =>
  (accounts || []).filter((account) => !account.deleted_at);

export function mapLeadStatusToStageIndex(status: string, onboardingStage: number): number {
  switch (status) {
    case 'new':
      return 1;
    case 'info_collected':
      return 1;
    case 'slot_selected':
      return 3;
    case 'subscription_created':
      return 8 + onboardingStage;
    case 'completed':
      return 8 + Math.max(onboardingStage, 7);
    case 'lost':
      return 8;
    default:
      console.warn('[MAP STATUS] Unknown status:', status, 'defaulting to stage 1');
      return 1;
  }
}

export function mapStageIndexToLeadStatus(stageIndex: number): string {
  if (stageIndex <= 2) return 'info_collected';
  if (stageIndex <= 6) return 'slot_selected';
  if (stageIndex === 7) return 'subscription_created'; // Gagné
  if (stageIndex === 8) return 'lost'; // Perdu
  if (stageIndex >= 9) return 'subscription_created'; // Onboarding
  console.warn('[MAP STAGE] Unknown stage index:', stageIndex, 'defaulting to info_collected');
  return 'info_collected';
}

export function mapAccountStatusToStageIndex(status: CRMAccount['status']): number {
  if (status === 'customer') return 7;
  if (status === 'churned') return 8;
  return 1;
}
